<div class="d-flex row-cols-12">
    <div class="col-7 mt-0">
        <h3 class="title float-start" translate="Settings.SystemOverviewSection.Title"></h3>
    </div>
    <!-- <div class="col-5 text-end">
        <button class="btn btn-sm btn-secondary mt-2 mb-2 me-4" *ngIf="user !== undefined && (user.isSystemAdmin || user.isWhitelabelAdmin)" (click)="changeOrganisation()" translate>Button.ChangeOrganisation</button>
    </div> -->
</div>
<div class="px-4 pt-1 pb-4">
    <div class="w-auto row row-cols-12">
        <div class="col-4">
            <div class="mb-2" translate="Settings.SystemOverviewSection.WhiteLabelProviders"></div>
            <app-settingsProgressBlock [TopLeft]="'Total'" [BottomLeft]="system.whiteLabelProvidersAmount"></app-settingsProgressBlock>
        </div>
        <div class="col-4">
            <div class="mb-2" translate="Settings.SystemOverviewSection.Organisations"></div>
            <app-settingsProgressBlock [TopLeft]="'Total'" [BottomLeft]="system.organisationAmount"></app-settingsProgressBlock>
        </div>
        <div class="col-4">
            <div class="mb-2" translate="Settings.SystemOverviewSection.Licences"></div>
            <app-settingsProgressBlock [TopLeft]="'Total'" [TopRight]="'Active'" [BottomLeft]="system.licencesAmount" [BottomRight]="system.licencesActive"></app-settingsProgressBlock>
        </div>
        <div class="row p-4 col-12">
            <span translate="Settings.SystemOverviewSection.Usage"></span>
        </div>
    </div>
    <app-system-signing-chart></app-system-signing-chart>
</div>